import * as React from 'react';

import * as styles from './newbuildingBuildersFacts.css';

export function NewbuildingBuildersFacts({ children }: React.PropsWithChildren<{}>) {
  return <div className={styles['container']}>{children}</div>;
}
